import { API_ROUTES } from '@config/routes';
import api from './api';
import type { Contact, PaginatedResponse } from '@/types';

export const contactService = {
  // Get all contacts
  getContacts: async (params?: {
    page?: number;
    pageSize?: number;
    search?: string;
    source?: string;
  }): Promise<PaginatedResponse<Contact>> => api.get(API_ROUTES.CONTACTS.BASE, { params }),

  // Get contact by ID
  getContactById: async (id: string): Promise<Contact> => api.get(API_ROUTES.CONTACTS.BY_ID(id)),

  // Create or update contact (upsert)
  upsertContact: async (data: {
    name: string;
    email: string;
    phone?: string;
    source?: string;
    sessionId?: string;
    metadata?: Record<string, unknown>;
  }): Promise<{ data: Contact; isNew: boolean }> => api.post(API_ROUTES.CONTACTS.BASE, data),

  // Create manual contact from dashboard Contacts tab
  createManualContact: async (data: {
    name: string;
    email: string;
    phone?: string;
    notes?: string;
  }): Promise<{ data: Contact; isNew: boolean }> =>
    api.post(API_ROUTES.CONTACTS.CREATE_MANUAL, data),

  // Update contact
  updateContact: async (id: string, data: Partial<Contact>): Promise<Contact> =>
    api.put(API_ROUTES.CONTACTS.BY_ID(id), data),

  // Delete contact
  deleteContact: async (id: string): Promise<void> => api.delete(API_ROUTES.CONTACTS.BY_ID(id)),
};
